"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var InvoiceField;
(function (InvoiceField) {
    InvoiceField["division"] = "division";
    InvoiceField["invoices"] = "invoices";
    InvoiceField["carriers"] = "carriers";
    InvoiceField["payer"] = "payer";
})(InvoiceField = exports.InvoiceField || (exports.InvoiceField = {}));
//# sourceMappingURL=InvoiceField.js.map